import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class InfoPageAdmin extends Component {
    constructor(props) {
      super(props);
      this.state = {
        infoPage: {},
        title: "",
        sections: [],
        editMode: false,
        updated: Date().toLocaleString()
      };

      this.getInfoPage = this.getInfoPage.bind(this);
      this.setEditMode = this.setEditMode.bind(this);
      this.handleChangeText = this.handleChangeText.bind(this);
      this.handleSectionChange = this.handleSectionChange.bind(this);
      this.addSection = this.addSection.bind(this);
      this.removeSection = this.removeSection.bind(this);
      this.moveSectionUp = this.moveSectionUp.bind(this);
      this.moveSectionDown = this.moveSectionDown.bind(this);
      this.handleSaveText = this.handleSaveText.bind(this);
      this.saveInfoPage = this.saveInfoPage.bind(this);
      this.setUpdatedBy = this.setUpdatedBy.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getInfoPage();

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      this.setState({
        infoPage: Object.assign({}, this.state.infoPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getInfoPage() {
      try {
        const response = await fetch("/api/pagedata/getInfoPage", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        });

        const data = await response.json();
        if (data && data.length > 0 && data[0]) {
          this.setState({
            infoPage: data[0],
            title: data[0].title || "",
            sections: data[0].sections || this.getDefaultSections(),
            updated: Date().slice(16, 24)
          });
        } else {
          // Handle empty database case - use default sections
          this.setState({
            infoPage: {},
            title: "Praktisk info",
            sections: this.getDefaultSections(),
            updated: Date().slice(16, 24)
          });
        }
      } catch (err) {
        console.log(err);
      }
    }

    getDefaultSections() {
      return [
        {
          id: 1,
          title: "Regler",
          content: "<br><h2>Regler</h2><br><br> <ul style='text-align:left;'><li>GAMERLAN er et rusfritt arrangement. Brudd på dette vil føre til umiddelbar utestengelse </li><li>Nødutganger skal ikke blokkeres under noen omstendigheter</li><li>Tyveri, hærverk, mobbing osv. blir politianmeldt</li><li>Høytalere er forbudt</li><li>Inngangsbånd skal være på under hele arrangementet</li><li>Soving skal skje i våre sovesoner. Er du i tvil om hvor du kan sove, spør crew</li><li>Vi tillater ikke bruk av hyller på plassene</li><li>Bruk av sparkesykler, ståhjulinger, radiostyrte biler osv. innendørs er ikke tillatt</li><li>GAMERLAN erstatter ikke eventuelt tap av utstyr</li><li>Vi kan refundere forhåndspåmeldinger inntil 48 timer før påmeldingen stenger</li><li>Ved brudd på disse regelene forbeholder vi oss retten til å bortvise</li><li>Vi forbeholder oss retten til å endre på regelene til enhver tid</li><li>GAMERLAN er et offentlig arrangement</li><li>Kjøps og salgsbetingelser finner du <a href='http://www.gamerlan.no/betingelser'>HER</a></li></ul>",
          order: 1
        },
        {
          id: 2,
          title: "Praktisk Informasjon",
          content: "<br><h2>Praktisk Informasjon</h2> <br> <br> <ul style='text-align:left;'> <b>HVA BØR DU HA MED? </b> <li>Bordplassen du får tildelt er ca 80cm bred. Dette tilsvarer bredden til en 37″ TV </li> <li> Samtykkeskjema om du er under 16 år, skjemaet finner du <a href='/__public/samtykkeskjema.pdf' target='blank'>HER</a> </li> <li>PC/Xbox/Playstation/Nintendo</li> <li>En minimum 5 meter lang nettverkskabel</li Om du glemmer nettverkskabel, tilbyr vi salg av kabler så lenge lageret rekker </li> <li>Strømkabel, skjermkabel, strømpadde</li> <li>Mus, tastatur og musematte </li> <li>Hodetelefoner. Vi tillater ikke eksterne høytalere</li> <li>Nettverkskort. Vi tilbyr trådløst, men kan ikke garantere stabiliteten i et rom med 50 - 100 deltakere</li> <li>Du får bare en nettverksport, ta med deg en switch om du skal koble opp flere enheter</li><li>Vi har stol du kan låne, men vær obs på at dette er typiske plaststoler som vi låner fra skolen</li> <li>Minnepenner er kjekt å ha på LAN</li> <li>Søppelposer - vi setter pris på at du holder det ryddig rundt deg</li> <li>Mobiltelefon med lader</li> <li>Penger - hvis du skal kjøpe mat på GAMERLAN <b>(VI TAR VIPPS OG KONTANTER, MEN IKKE BANKKORT)</b></li> <li>Superviktig! Tannbørste, barbersager, deodorant og såpe</li> <li>Sovepose, pute og liggeunderlag (NB. Oppblåsbare dobbeltsenger anbefales ikke, de tar mye plass)</li> <li>Klesskift / Rene klær</li> <li>Alle medikamenter du måtte trenge i løpet av helgen. Du bør alltid ha på deg evt. nødvendig medisinsk dokumentasjon</li> <br> <b>MAT</b> <li>Vi anbefaler at du kjøper noen brødskiver og pålegg (syltetøy på tube, ferdigoppskjært ost, etc). </li>  <li>Det finnes Matbutikker i nærheten, nærmeste er Kiwi ca. 350 Meter unna</li> <br> <b>TING DU IKKE TRENGER</b> <li>Kjøleskap</li> <li>Mikrobølgeovn</li> <li>Vannkoker</li> <li>Høyttalere</li> <li>Andre apparater som trekker mye strøm</li> <br> <br> <b>HUSK AT DETTE ER ET 100% RUSFRITT ARRANGEMENT</b> </ul>",
          order: 2
        },
        {
          id: 3,
          title: "Om påmelding",
          content: "<br><b><h2> Om påmelding </h2></b> <br> <br> <ul style='text-align:left;'><li>Forhåndspåmeldinger betales kun med Vipps</li> <li>Har du ikke mulighet til å betale med Vipps må du dessverre satse på at det er ledige plasser ved oppmøte, og betale kontant</li> <li>Betalingsfristen er 3 døgn fra påmelding</li> <li>Hvis betalingen ikke er mottatt innen fristen vil reservasjonen din slettes</li><li>Ved gjentatte påmeldinger uten betaling kan du blokkeres fra videre påmeldingsforsøk</li> <li>Du kan ta kontakt med oss for å refundere en påmelding inntil 48 timer før påmeldingen stenger</li> <li>Påmeldingen stenges noen dager før LAN. Be oss om refusjon senest en uke før, for å være sikker</li> <li>Betalingsinformasjon får du tilsendt på mail etter påmeldingen er fullført</li> <li>Som nevnt i mailen er det viktig at du skriver inn din unike kode som kommentar på Vipps-betalingen</li> <li>For informasjon om hvordan du kan betale i Vipps, trykk <a href='http://www.gamerlan.no/betaling'>HER</a></li><li>GAMERLAN drives 100% frivillig og alle pengene går tilbake inn i arrangementet</li><li>Vi setter dermed stor pris på om påmeldinger kan betales innen fristen, slik at vi ikke trenger å bruke fritiden på å sende ut purringer osv. :)</li></ul>",
          order: 3
        }
      ];
    }

    handleSectionChange(sectionId, field, value) {
      const updatedSections = this.state.sections.map(section => {
        if (section.id === sectionId) {
          return { ...section, [field]: value };
        }
        return section;
      });
      this.setState({ sections: updatedSections });
    }

    addSection() {
      const newId = Math.max(...this.state.sections.map(s => s.id), 0) + 1;
      const newOrder = Math.max(...this.state.sections.map(s => s.order), 0) + 1;
      const newSection = {
        id: newId,
        title: "Ny seksjon",
        content: "<h3>Ny seksjon</h3><p>Innhold her...</p>",
        order: newOrder
      };
      this.setState({ sections: [...this.state.sections, newSection] });
    }

    removeSection(sectionId) {
      if (this.state.sections.length <= 1) {
        alert("Du må ha minst én seksjon");
        return;
      }
      if (window.confirm("Er du sikker på at du vil slette denne seksjonen?")) {
        const updatedSections = this.state.sections.filter(section => section.id !== sectionId);
        this.setState({ sections: updatedSections });
      }
    }

    moveSectionUp(sectionId) {
      const sections = [...this.state.sections];
      const currentIndex = sections.findIndex(s => s.id === sectionId);
      if (currentIndex > 0) {
        [sections[currentIndex], sections[currentIndex - 1]] = [sections[currentIndex - 1], sections[currentIndex]];
        // Update order values
        sections.forEach((section, index) => {
          section.order = index + 1;
        });
        this.setState({ sections });
      }
    }

    moveSectionDown(sectionId) {
      const sections = [...this.state.sections];
      const currentIndex = sections.findIndex(s => s.id === sectionId);
      if (currentIndex < sections.length - 1) {
        [sections[currentIndex], sections[currentIndex + 1]] = [sections[currentIndex + 1], sections[currentIndex]];
        // Update order values
        sections.forEach((section, index) => {
          section.order = index + 1;
        });
        this.setState({ sections });
      }
    }

    setEditMode() {
      this.setState({ editMode: !this.state.editMode });
    }

    handleChangeText(event) {
      if (event.target.name === "title") {
        this.setState({
          title: event.target.value,
          infoPage: Object.assign({}, this.state.infoPage, {
            title: event.target.value
          })
        });
      } else {
        this.setState({ [event.target.name]: event.target.value });
      }
    }

    setUpdatedBy() {
      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";
      this.setState({
        infoPage: Object.assign({}, this.state.infoPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    async handleSaveText() {
      this.setUpdatedBy();
      await this.saveInfoPage();
    }

    async saveInfoPage() {
      let infoPage = {
        title: this.state.title,
        sections: this.state.sections.sort((a, b) => a.order - b.order),
        UpdatedBy: this.state.infoPage.UpdatedBy
      };

      try {
        const response = await authenticatedFetch("/api/admin/updateInfoPage", {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(infoPage)
        });

        if (response.ok) {
          // Clear the page cache so changes are reflected immediately
          try {
            await fetch("/api/pagedata/clearInfoPageCache", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });
          } catch (cacheError) {
            console.log("Cache clear failed, but update succeeded:", cacheError);
          }

          alert("Infoside oppdatert!");
          this.setState({ editMode: false, updated: Date().slice(16, 24) });
        } else {
          alert("Feil ved oppdatering av infoside");
        }
      } catch (err) {
        console.log("Error updating info page:", err);
        alert("Feil ved oppdatering av infoside");
      }
    }

    render() {
      if (this.props.authenticated === null) return null;

      return (
        <div className="SignupList">
          <h1>Infoside Admin</h1>
          <p>Sist oppdatert: {this.state.updated}</p>
          <p>Oppdatert av: {this.state.infoPage.UpdatedBy || "Ukjent"}</p>

          <button
            className="btn btno btn-success edit"
            onClick={this.setEditMode}
          >
            {this.state.editMode ? "Avbryt redigering" : "Rediger infoside"}
          </button>

          {this.state.editMode && (
            <button
              className="btn btno btn-primary edit"
              onClick={this.handleSaveText}
              style={{ marginLeft: "10px", cursor: "pointer" }}
            >
              Lagre endringer
            </button>
          )}

          {this.state.editMode ? (
            <div style={{ marginTop: "20px" }}>
              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h3>Rediger sidetittel:</h3>
                  <div className="form-group">
                    <label htmlFor="title"><strong>Sidetittel:</strong></label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleChangeText}
                      style={{ marginBottom: "20px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h3>Forhåndsvisning tittel:</h3>
                  <div style={{ border: "1px solid #495057", padding: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                    <h4>Sidetittel</h4>
                    <div dangerouslySetInnerHTML={{ __html: this.state.title }} />
                  </div>
                </div>
              </div>

              <hr />

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h3>Seksjoner:</h3>
                <button
                  className="btn btn-success"
                  onClick={this.addSection}
                  type="button"
                  style={{ cursor: "pointer" }}
                >
                  + Legg til seksjon
                </button>
              </div>

              {this.state.sections
                .sort((a, b) => a.order - b.order)
                .map((section, index) => (
                  <div key={section.id} style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                    <div style={{ flex: "1", border: "2px solid #ddd", padding: "15px", borderRadius: "5px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                        <h4>Rediger Seksjon {index + 1}</h4>
                        <div>
                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => this.moveSectionUp(section.id)}
                            disabled={index === 0}
                            style={{ marginRight: "5px", cursor: "pointer" }}
                            type="button"
                          >
                            ↑
                          </button>
                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => this.moveSectionDown(section.id)}
                            disabled={index === this.state.sections.length - 1}
                            style={{ marginRight: "5px", cursor: "pointer" }}
                            type="button"
                          >
                            ↓
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => this.removeSection(section.id)}
                            type="button"
                            style={{ cursor: "pointer" }}
                          >
                            🗑️
                          </button>
                        </div>
                      </div>

                      <div className="form-group">
                        <label><strong>Tittel:</strong></label>
                        <input
                          type="text"
                          className="form-control"
                          value={section.title}
                          onChange={(e) => this.handleSectionChange(section.id, 'title', e.target.value)}
                          style={{ marginBottom: "10px" }}
                        />
                      </div>

                      <div className="form-group">
                        <label><strong>Innhold:</strong></label>
                        <textarea
                          className="form-control"
                          rows="15"
                          value={section.content}
                          onChange={(e) => this.handleSectionChange(section.id, 'content', e.target.value)}
                          style={{ minHeight: "400px" }}
                        />
                      </div>
                    </div>

                    <div style={{ flex: "1", border: "1px solid #495057", padding: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                      <h4>Forhåndsvisning Seksjon {index + 1}</h4>
                      <div dangerouslySetInnerHTML={{ __html: section.title }} />
                      <div dangerouslySetInnerHTML={{ __html: section.content }} />
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div style={{ marginTop: "20px", maxWidth: "1000px", margin: "20px auto" }}>
              <h3>Forhåndsvisning:</h3>

              <div style={{ border: "1px solid #495057", padding: "20px", marginBottom: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                <h4>Sidetittel</h4>
                <div dangerouslySetInnerHTML={{ __html: this.state.title }} />
              </div>

              {this.state.sections
                .sort((a, b) => a.order - b.order)
                .map((section, index) => (
                  <div key={section.id} style={{ border: "1px solid #495057", padding: "20px", marginBottom: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                    <div dangerouslySetInnerHTML={{ __html: section.title }} />
                    <div dangerouslySetInnerHTML={{ __html: section.content }} />
                  </div>
                ))}
            </div>
          )}
        </div>
      );
    }
  }
);


// WEBPACK FOOTER //
// ./src/Components/Admin/InfoPageAdmin.js